angular.module('theme').directive('customEvent', function (TrackerService) {
	return {
		restrict: 'A',
		link: function ($scope, $element, $attrs) {
			angular.element($element[0]).bind('click', function () {
				var eventType = $attrs.customEvent;
				var category = $attrs.customEventCategory;
				var action = $attrs.customEventAction;
				TrackerService.customEvent(eventType, category, action);
			});
		}
	};
});
